"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
exports.default = react_1.forwardRef(function CardContent(props, ref) {
    return jsx_runtime_1.jsx(CardContent_1.default, __assign({}, props, { ref: ref }), void 0);
});
//# sourceMappingURL=CardContent.js.map